<template>
  <fragment>
    <AppBody
      :title="$t('reports.eleven.financial')"
      :subtitle="$t('reports.eleven.financial')"
      info
      :infoMessage="$t('reports.eleven.info')"
      disableDivider
    >
      <CardModule untitle>
        <v-form
          @submit.prevent="
            $relatorios_analiticos.filtroAnaliticoFinanceiroOmni(
              $relatorios_analiticos.filterFinanceiroOmni.tipo_pessoa
            )
          "
          class="search-forms"
        >
          <v-row v-if="isAdmin">
            <v-col
              cols="12"
              md="3"
              sm="4"
              v-if="
                $relatorios_analiticos.filterFinanceiroOmni.tipo_pessoa ==
                'PONTO_VENDA'
              "
            >
              <BaseAutocomplete
                v-model="
                  $relatorios_analiticos.filterFinanceiroOmni.pontos_de_venda
                "
                :label="$t('reports.point-of-sale.input')"
                :placeholder="$t('reports.point-of-sale.select')"
                :items="$pointOfSale.pontos_de_venda"
                data-cy="ponto-venda"
                :filterFinanceiroOmni="search"
                item-text="representante_nome"
                item-value="idponto_venda"
                no-data-text="Nenhuma loja encontrada"
                clearable
                @click:clear="
                  $relatorios_analiticos.clearfilterFinanceiroOmniFields('loja')
                "
              >
                <template v-slot:selection="{ item }">
                  <div v-if="item ? (representante_nome = item) : null">
                    {{ item.representante_nome }}
                  </div>
                </template>
              </BaseAutocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseSelect
                v-model="$relatorios_analiticos.filterFinanceiroOmni.regional"
                :label="$t('reports.general-sales.regional')"
                :placeholder="$t('reports.general-sales.select-regional')"
                :no-data-text="$t('reports.no-info-found')"
                :items="$loja_gerenciar.regionais"
                loader-height="5"
                item-text="nome"
                item-value="idregional"
                :disabled="disableRegionais"
                data-cy="regional"
                clearable
                @click:clear="
                  $relatorios_analiticos.clearfilterFinanceiroOmniFields(
                    'regional'
                  )
                "
              />
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseAutocomplete
                v-model="estado"
                :label="$t('reports.eleven.state')"
                :placeholder="$t('reports.eleven.select-state')"
                :no-data-text="$t('reports.no-info-found')"
                item-text="dsc_lang"
                item-value="iso_full"
                return-object
                autocomplete="null"
                auto-select-first
                clearable
                :loading="$config.loading_estados"
                :items="$config.estados.result"
                @click:clear="
                  $relatorios_analiticos.clearfilterFinanceiroOmniFields(
                    'estado'
                  )
                "
              >
              </BaseAutocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseAutocomplete
                v-model="$relatorios_analiticos.filterFinanceiroOmni.cidade"
                :label="$t('reports.eleven.city')"
                :placeholder="$t('reports.eleven.select-city')"
                :no-data-text="$t('reports.no-info-found')"
                item-text="dsc_lang"
                item-value="dsc_lang"
                clearable
                :loading="$config.loading_cidades"
                :items="$config.cidades.result"
                @click:clear="
                  $relatorios_analiticos.clearfilterFinanceiroOmniFields(
                    'cidade'
                  )
                "
              >
              </BaseAutocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseSelect
                v-model="
                  $relatorios_analiticos.filterFinanceiroOmni.canal_de_venda
                "
                :label="$t('reports.channel-sales.input')"
                :placeholder="$t('reports.channel-sales.select')"
                :no-data-text="$t('reports.no-info-found')"
                :items="$relatorios_analiticos.canais_de_venda"
                data-cy="canal-venda"
                item-text="value"
                item-value="key"
                clearable
                @click:clear="
                  $relatorios_analiticos.clearfilterFinanceiroOmniFields(
                    'canal_de_venda'
                  )
                "
              />
            </v-col>

            <v-col cols="12" md="3" sm="4">
              <date-time-picker
                :label="$t('reports.financial-producer.initial-date-order')"
                @formatted-date="handleInitDateTimeOrders"
              ></date-time-picker>
            </v-col>

            <v-col cols="12" md="3" sm="4">
              <date-time-picker
                :label="$t('reports.financial-producer.final-date-order')"
                @formatted-date="handleEndDateTimeOrders"
              ></date-time-picker>
            </v-col>

            <v-col cols="12" md="3" sm="4">
              <date-time-picker
                :label="
                  $t('reports.financial-producer.initial-date-liberation')
                "
                @formatted-date="handleInitDateTimeRelease"
              ></date-time-picker>
            </v-col>

            <v-col cols="12" md="3" sm="4">
              <date-time-picker
                :label="$t('reports.financial-producer.final-date-liberation')"
                @formatted-date="handleEndDateTimeRelease"
              ></date-time-picker>
            </v-col>

            <v-col class="d-flex justify-end">
              <BaseButton
                tabindex="12"
                variant="filter"
                data-cy="filtrar"
                class="button rounded-xxl"
                type="submit"
                :loading="
                  $relatorios_analiticos.loading_relatorio_financeiro_omni
                "
              >
                {{ $t("reports.generate-and-send") }}
              </BaseButton>
            </v-col>
          </v-row>
        </v-form>
      </CardModule>
    </AppBody>
  </fragment>
</template>
<script>
import dayjs from "dayjs";
import CardModule from "@/components/cards/CardModule.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import DateTimePicker from "@/components/forms/DateTimePicker.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import AppBody from "@/layouts/components/AppBody.vue";
export default {
  name: "FinancialAnalyticalEleventickets",
  metaInfo: {
    title: "Relatório Analítico Financeiro | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Relatório Analítico Financeiro | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    CardModule,
    DateTimePicker,
    BaseSelect,
    BaseAutocomplete,
    BaseButton,
    AppBody,
  },
  data() {
    return {
      dayjs: dayjs,
      disableRegionais: false,
      estado: null,
      cidades: [],
      tipo_pessoa: [],
    };
  },
  watch: {
    estado(state) {
      const { id, iso_full } = state;
      this.$relatorios_analiticos.filterFinanceiroOmni.estado = iso_full;

      const filteredId = this.$config.estados.result.find(
        item => item.dsc === state
      );

      this.$config.getCidades(id || filteredId.id);
    },
    "$relatorios_analiticos.filterFinanceiroOmni.loja"(e) {
      if (e === null || e === undefined || e === "") {
        this.disableRegionais = false;
        return;
      } else {
        this.disableRegionais = true;
        this.$produtos_gerenciar.getProdutos(e);
      }
    },
    "$relatorios_analiticos.filterFinanceiroOmni.regional"(e) {
      if (e === null) {
        this.$relatorios_analiticos.getAllLojas();
        return;
      }
      this.$relatorios_analiticos.getLojasByRegional(e);
    },
    "$relatorios_analiticos.filterFinanceiroOmni.tipo_pessoa"(e) {
      this.$relatorios_analiticos.filterFinanceiroOmni.pontos_de_venda = null;
      switch (e) {
        case "idponto_venda":
          this.$pointOfSale.getPointsOfSale();
          break;
        case "idloja":
          if (this.$loja_gerenciar.lojas.length == 0) {
            this.$loja_gerenciar.getAllLojas();
          }
          break;
      }
    },
  },
  methods: {
    handleInitDateTimeOrders(formatteddatetime) {
      this.$relatorios_analiticos.filterFinanceiroOmni.initDateTimeOrders =
        formatteddatetime;
    },
    handleEndDateTimeOrders(formatteddatetime) {
      this.$relatorios_analiticos.filterFinanceiroOmni.endDateTimeOrders =
        formatteddatetime;
    },
    handleInitDateTimeRelease(formatteddatetime) {
      this.$relatorios_analiticos.filterFinanceiroOmni.initDateTimeRelease =
        formatteddatetime;
    },
    handleEndDateTimeRelease(formatteddatetime) {
      this.$relatorios_analiticos.filterFinanceiroOmni.endDateTimeRelease =
        formatteddatetime;
    },
  },

  computed: {
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return true;
      return false;
    },
  },
  beforeMount() {
    this.$axios.setLocal("person_type", "LOJA");
  },
  mounted() {
    this.$config.getEstados("9e1bf96ca2754ee6596f26fd6e6b5cc2");
    this.$relatorios_analiticos.getCanaisDeVenda();
    this.$relatorios_analiticos.getFormasDePagamento();
    if (!this.isAdmin) {
      this.$produtos_gerenciar.getProdutos(
        this.$axios.getLocal("oe_user_info")?.data?.loja
      );
      return;
    }
    this.$loja_gerenciar.getRegionais();
  },
  destroyed() {
    this.$relatorios_analiticos.limpaFiltrosFinanceiroOmni();
  },
};
</script>
<style scoped></style>
